<template>
  <div class="basic-autocomplete-container">
    <Field
      v-slot="{ field }"
      v-model="mutatedValue"
      :label="label"
      :name="name"
      :rules="validation"
      tag="div"
      class="basic-autocomplete-contain"
    >
      <v-select
        :ref="name"
        v-model="mutatedValue"
        class="custom-select-style bordered-bottom"
        :clearable="true"
        v-bind="field"
        :get-option-label="generateLabel"
        :options="mutatedDataOptions"
        :loading="loadingDatas"
        append-to-body
        :disabled="isReadOnly"
        :placeholder="label"
        @option:selected="onChange"
        @open="openSelect()"
      >
        <template #no-options="{ searching }">
          <template v-if="searching">
            {{ $t('errors.datas_not_found') }}
          </template>
        </template>
        <template #spinner="{ loading }">
          <img
            v-if="loading"
            style="width: 1rem; height: 1rem; margin-left: 5px"
            src="@/assets/icons/spinner-dots.svg"
            alt="loader"
          >
        </template>
        <template #open-indicator>
          <img
            style="width: 0.9rem; height: 0.9rem"
            src="@/assets/icons/arrow-down.svg"
            alt="display options"
          >
        </template>
      </v-select>
      <ErrorMessage
        class="error-msg"
        :name="name"
      />
    </Field>
    <transition name="slideleft">
      <FullScreenSelect
        v-if="showSelectorFS"
        :defaultValue="mutatedValue"
        :options="mutatedDataOptions"
        :name="label"
        :labelFields="labelFields"
        :searchbar="true"
        :parentType="'BasicAutocomplete'"
        @fs-select-close="showSelectorFS = false"
        @selected-option="onChange"
      />
    </transition>
  </div>
</template>

<script>
import { configurationService } from '@/services/configuration.service'
import { Field, ErrorMessage } from 'vee-validate'
import { store } from '@/stores/index.js'
import { mapState } from 'pinia'
import FullScreenSelect from '@/components/GenericComponents/Form/FullScreenSelect.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  name: 'BasicAutocomplete',
  components: {
    Field,
    ErrorMessage,
    FullScreenSelect,
    vSelect
  },
  props: {
    label: String,
    validation: [String, Boolean],
    placeholder: [String, Number],
    defaultValue: [String, Array, Object],
    name: String,
    dataOptions: Array,
    apiUrl: String,
    labelFields: Array,
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue,
      mutatedDataOptions: this.dataOptions,
      loadingDatas: true,
      showSelectorFS: false
    }
  },
  computed: {
    ...mapState(store, ['deviceType'])
  },
  async mounted() {
    if (this.apiUrl) {
      this.mutatedDataOptions = await configurationService.getFormData(this.apiUrl, null)
      if (this.placeholder === undefined && this.mutatedDataOptions && this.mutatedDataOptions.length > 0) {
        this.mutatedValue = this.mutatedDataOptions[0]
        this.$emit('addData', { value: this.mutatedValue.login_user, name: this.name })
      }
    }
    if (this.mutatedValue !== undefined) {
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
    } else {
      this.$emit('addData', { value: '', name: this.name })
    }
    this.loadingDatas = false
  },
  methods: {
    generateLabel(obj) {
      let label = ''
      this.labelFields.forEach(field => {
        if (label === '') {
          label = obj[field]
        } else {
          label = label + ' ' + obj[field]
        }
      })
      return label
    },
    onChange(value) {
      const removeRef = JSON.parse(JSON.stringify(value))
      this.mutatedValue = value
      this.$emit('addData', { value: removeRef, name: this.name })
    },
    openSelect() {
      if (this.deviceType !== 'desktop') {
        document.activeElement.blur()
        this.showSelectorFS = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .basic-autocomplete-container {
    margin: 10px 0;

    .custom-select-style {
      width: 100%;
      white-space: nowrap;
      align-items: center;
      padding-left: 0.5rem;
      margin-top: 9px;
    }
  }
</style>

<style lang="scss">
  .basic-autocomplete-container {
    .custom-select-style input {
      height: 100%;
      border: none;
    }

    .vs__dropdown-toggle {
      display: flex;
      align-items: center;
    }

    .vs__selected-options {
      margin-right: 5px;
    }

    .custom-select-style * {
      padding: 0 0 1px !important;
      border: none !important;
    }

    .custom-select-style .vs__clear {
      fill: transparent;
      background-image: url('@/assets/icons/cancel.svg');
      background-position: center right;
      background-origin: content-box;
      background-repeat: no-repeat;
      background-size: contain;
      width: 1rem;
      height: 1rem;
      margin-right: 8px !important;
    }
  }

  .slideleft-enter-active,
  .slideleft-leave-active {
    transition: transform 0.3s;
  }

  .slideleft-enter-from,
  .slideleft-leave-to {
    transform: translateX(-100%);
  }
</style>
